/**
 * Checks whether two time ranges overlap (have any shared time).
 *
 * Two ranges are considered non-overlapping (excluded) when:
 *   a.finish <= b.start || b.finish <= a.start
 *
 * A null boundary means unbounded (negative infinity for start, positive
 * infinity for finish), so a null boundary never causes exclusion.
 * @param {{ start: object|null, finish: object|null }} rangeA
 * @param {{ start: object|null, finish: object|null }} rangeB
 * @returns {boolean} true if the ranges overlap
 */
export const hasTimeRangeOverlap = (rangeA, rangeB) => {
  // If a.finish exists and b.start exists, check a.finish <= b.start
  if (rangeA.finish && rangeB.start && rangeA.finish <= rangeB.start) {
    return false;
  }

  // If b.finish exists and a.start exists, check b.finish <= a.start
  if (rangeB.finish && rangeA.start && rangeB.finish <= rangeA.start) {
    return false;
  }

  return true;
};

/**
 * Checks whether two time ranges are excluded (have no overlap).
 * This is the logical inverse of {@link hasTimeRangeOverlap}.
 * @param {{ start: object|null, finish: object|null }} rangeA
 * @param {{ start: object|null, finish: object|null }} rangeB
 * @returns {boolean} true if the ranges have no overlap
 */
export const isTimeRangeExcluded = (rangeA, rangeB) => !hasTimeRangeOverlap(rangeA, rangeB);
